<template>
    <!-- bred crumb section start -->
    <section class="game-detail-crumb lg:pt-[8rem] pt-[6rem] pb-[2rem]">
    </section>
    <!-- bred crumb section end -->
    <!-- game page card prop up start -->
    <section
      class="sm:pt-[60px] pt-12 lg:pb-[100px] md:pb-20 sm:pb-16 pb-12 bg-nu2"
    >
      <div class="container mx-auto" v-if="currGame">
        <div class="flex flex-wrap">
          <!-- show -->
          <div class="game-icon w-full sm:w-1/3 flex flex-col items-center justify-center">
            <!-- png -->
            <img :src="currGame.icon" class="w-[200px] lg:w-[300px] md:w-[200px] object-cover rounded-lg img" alt="game-icon" />
            <!-- btn -->
            <button class="bg-[#8d8d8d] text-nu2 rounded-lg w-[120px] lg:w-[180px] md:w-[120px] py-2 my-3">
              Play Now
            </button>
            <!-- svg -->
             <div class="flex gap-1">
               <PhDesktop class="sm:px-2 px-1 sm:py-2 py-1 bg-[#8d8d8d] duration-700 hover:bg-primary rounded-xl" size="2rem" weight="bold" />
               <PhDeviceMobile class="sm:px-2 px-1 sm:py-2 py-1 bg-[#8d8d8d] duration-700 hover:bg-primary rounded-xl" size="2rem" weight="bold" />
             </div>
          </div>
          <!-- detail -->
          <div class="game-detail w-full sm:w-2/3 mt-10 sm:mt-0" data-aos="zoom-in">
            <!-- title -->
            <h1 class="text-nu1 text-[24px] font-bold pb-2">{{ currGame.title }}</h1>
            <!-- description -->
            <div class="flex gap-2">
              <div class="text-nu1 sm:pt-3 pt-2 w-1/2 flex flex-col items-center justify-center bg-[#18191f] rounded-lg">
                <div class="flex items-center justify-center">
                  <PhPulse class="text-2xl" weight="bold" />
                  <span class="text-xs xl:text-xl pl-1 inline-block">Volatility</span>
                </div>
                <span class="text-lg text-[#ffc600]">{{ currGame.volatility }}</span>
              </div>
              <div class="text-nu1 sm:pt-3 pt-2 lg:mr-7 w-1/2 flex flex-col items-center justify-center bg-[#18191f] rounded-lg">
                <div class="flex items-center justify-center">
                  <PhGift class="text-2xl" weight="bold" />
                  <span class="text-xs xl:text-xl pl-1">Maximum Win</span>
                </div>
                <span class="text-lg ml-1 text-[#ffc600]"><span class="text-xs inline pr-1">X</span>{{ currGame.max_win }}</span>
              </div>
            </div>
            <div class="grid grid-cols-3 gap-2 ml-2 border-b border-nu1 pt-2">
              <div class="text-[#ffc600] text-[16px] col-span-1 py-2">Hot</div>
              <div class="col-span-2 py-2">
                <PhFire v-for="i in currGame.hot" :key="i" class="text-nu15 text-[30px] inline-block" weight="fill" />
              </div>
            </div>
            <div class="grid grid-cols-3 gap-2 ml-2 border-b border-nu1 pt-2">
              <div class="text-[#ffc600] text-[16px] col-span-1 py-2">Type of Game</div>
              <div class="col-span-2 py-2 text-nu1">
                {{ currGame.type }}
              </div>
            </div>
            <div class="grid grid-cols-3 gap-2 ml-2 border-b border-nu1 pt-2">
              <div class="text-[#ffc600] text-[16px] col-span-1 py-2">Special Features</div>
              <div class="col-span-2 py-2 text-nu1">
                {{ currGame.desc }}
              </div>
            </div>
            <div class="grid grid-cols-3 gap-2 ml-2 border-b border-nu1 pt-2">
              <div class="text-[#ffc600] text-[16px] col-span-1 py-2">Paylines</div>
              <div class="col-span-2 py-2 text-nu1">
                {{ currGame.paylines }} {{ currGame.paylines == '-' ? '' : 'Lines' }}
              </div>
            </div>
            <div class="grid grid-cols-3 gap-2 ml-2 border-b border-nu1 pt-2">
              <div class="text-[#ffc600] text-[16px] col-span-1 py-2">Publish Time</div>
              <div class="col-span-2 py-2 text-nu1">
                {{ currGame.online_date }}
              </div>
            </div>
            
            <!-- country -->
            <div class="game-country mt-2">
              <span class="text-nu1 text-[16px]">Supported Languages</span>
              <div class="flex gap-2 flex-wrap">
                <img v-for="c in countryIcons" :key="c.id" class="w-10 h-auto" :src="c.icon" alt="country-icon" />
              </div>
            </div>
          </div>
        </div>
        <div v-if="currGame.screenshot" class="text-center w-[90%] sm:w-[80%] mx-auto">
          <div class="text-center py-10 flex items-center justify-center">
            <span class="title-left"></span>
            <span class="mx-5 text-nu1 text-[24px] font-bold">Game Display</span>
            <span class="title-right"></span>
          </div>
          <swiper
            :spaceBetween="10"
            :autoHeight="true"
            :centeredSlidesBounds="true"
            :breakpoints="{
              1400: {
                slidesPerView: 3,
                spaceBetween: 1,
              },
              1200: {
                slidesPerView: 3,
                spaceBetween: 1,
              },
              992: {
                slidesPerView: 3,
                spaceBetween: 1,
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 1,
              },
              578: {
                slidesPerView: 2,
                spaceBetween: 1,
              },
              375: {
                slidesPerView: 1,
                spaceBetween: 1,
              },
            }"
            :modules="modules"
            class="swiper-container"
          >
            <swiper-slide v-for="pic in currGame.screenshot" :key="pic" class="swiper-slide" @click="showPic(pic)">
              <img :src="pic" class="w-[300px] lg:w-[300px] md:w-[200px] object-cover rounded-lg img" alt="game-icon"/>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div v-if="currPic" class="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50" @click="currPic = ''">
        <img :src="currPic" class="max-w-[90%] max-h-[90%]">
      </div>
    </section>
</template>

<script setup>
  import gameJson from '~~/static/data/game.json';
  import AOS from 'aos';
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import { PhDesktop, PhDeviceMobile, PhGift, PhFire, PhPulse } from "@phosphor-icons/vue";
  // import required modules
  import { Autoplay, Pagination, Navigation } from 'swiper/modules';

  const route = useRoute();
  const currGame = computed(() => {
    return gameJson.games.find((game) => game.id === Number(route.params.id));
  })
  const modules = [Autoplay, Pagination, Navigation];
  const currPic = ref('');

  const countryIcons = [
    { id: 1, icon: '/img/about/country/1.png' },
    { id: 2, icon: '/img/about/country/2.png' },
    { id: 3, icon: '/img/about/country/3.png' },
    { id: 4, icon: '/img/about/country/4.png' },
    { id: 5, icon: '/img/about/country/5.png' },
    { id: 6, icon: '/img/about/country/6.png' },
    { id: 7, icon: '/img/about/country/7.png' },
    { id: 8, icon: '/img/about/country/8.png' },
    { id: 9, icon: '/img/about/country/9.png' },
    { id: 10, icon: '/img/about/country/10.png' },
  ]

  const showPic = (srcUrl) => {
    currPic.value = srcUrl;
  }

  // 页面激活后，需要初始化aos
  onMounted(() => {
    AOS.init({
      duration: 2000,
      delay: 5000,
      once: true,
    });
  });
</script>

<script>
  export default {
    name: 'Game',
  }
</script>

<style scoped lang="scss">
  .game-country {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 10px;
    background-color: rgba(141,141,141,0.2);
    padding: 10px;
    border-radius: 5px;
  }

  .swiper-container {
    margin: 0 auto;
  }
  .swiper-slide {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .title-left, .title-right {
    content: '';
    flex: 1;
    height: 1px;
    background-color: #8d8d8d;
  }
  
</style>